export default __webpack_public_path__ + "static/image11-a6c6650306a52e3d2fbbe46bd5c3eb8f.gif";